<template>
  <div class="complete">
    <!-- <router-link to="/makeinvoice" class="left" v-if="sureInvoicing">开具发票</router-link> -->
    <div class="right" @click="againBuyingTickets">
      <div class="surplus">Book the ticket again</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "complete",
  props: ['ticketlist', 'base', 'orderId', 'orderDetails'],
  data () {
    return {
      sureInvoicing: null,
    }
  },
  methods: {
    againBuyingTickets(){
      this.$router.push(this.ticketlist);
    },
  },
  watch: {
    orderDetails: {
      handler(newValue){
        if(!newValue)return;
        this.sureInvoicing = newValue.itemList.some((item) => (item.canInvoice == 1 && item.invoiceStatus == 0) && (item.ticketStatus === '3' || item.ticketStatus === '4'));
      },
      immediate: true
    }
  },
};
</script>

<style scoped lang='less'>
.complete{
  height: 1.6rem;
  position: fixed;
  width: 100%;
  display: flex;
  bottom: 0;
  left: 0;
  .left{
    color: #C4D1E3;
    font-size: .426667rem;
    background: #FDF1E1;
    line-height: 1.6rem;
    padding: 0 1.066667rem;
  }
  .right{
    background: #3B6D9C;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .surplus{
      color: rgba(255, 255, 255, 1);
      font-size: .24rem  * 2;
    }
    .continue{
      color: #FFFFFF;
      font-size: .24rem * 2;
    }
  }
}
</style>
